import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

type SincronizarPeriodosPayload = {
  periodoIds: number[];
};

export const sincronizarPeriodosCotaUsuarioService = async (
  cotaUsuarioId: number,
  values: SincronizarPeriodosPayload
) => {
  const token = validateToken();

  if (!token) {
    return null;
  }

  const url = `${Globais.DOMINIOBACK}/cota-usuario/diagnostico/irregularidades/${cotaUsuarioId}/periodos/sincronizar`;

  try {
    const response = await axios.put(url, values, {
      headers: { Authorization: token.AuthStr },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
